/* tslint:disable */

/**
 */
export class ProductUpdateParams {
    name?: string;
    dim1?: number;
    dim2?: number;
    dim3?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/product-update-params.ts